/**
 * Checks if the given value is a symbol.
 */
export function isSymbol(value: unknown) {
  return (
    typeof value === "symbol" ||
    (value != null && typeof value === "object" && Object.prototype.toString.call(value) === "[object Symbol]")
  )
}
